export function EmailData() {
    return {
        name: "email",
        label: "Email",
        primitiveType: "string",
    };
}

export default EmailData;
